import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UserService } from '../../services/user.service';
import { LoginComponent } from '../../login/login/login.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'auto-login',
  template: '' // No template needed unless you want a loading spinner, etc.
})
export class AutoLoginComponent implements OnInit, OnDestroy {
  private userServiceBroadcastSubscription!: Subscription;
  private modalRef: NgbModalRef | undefined;
  token: string = '';
  criteria: string = '';
  
  //@Input() token!: string;
  //@Input() criteria!: string;
   	
  constructor(
    private userService: UserService,
    private modalService: NgbModal,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') || '';
	this.criteria = this.route.snapshot.paramMap.get('criteria') || '';
	
    this.userService.autologin(this.token, this.criteria ?? '');
    
    this.userServiceBroadcastSubscription = this.userService.broadcastEvent.subscribe((eventId) => {
      if("login" === eventId){
      	this.showLogin();
      }
    });
  }
  ngOnDestroy() {
		if (this.userServiceBroadcastSubscription) {
			this.userServiceBroadcastSubscription.unsubscribe();
		}
  }
  showLogin() {
        this.modalRef = this.modalService.open(LoginComponent, {
			size: 'md'
		});
	  this.modalRef.result.then(
	  (payload: any) => {
		console.log('Login page loaded.');
	  },
	  (reason: any) => {
	    // Handle `reason` as a string or error object
	    if (typeof reason === 'string') {
	      console.log('Modal dismissed:', reason);
	    } else if (reason instanceof Error) {
	      console.log('Modal dismissed due to error:', reason.message);
	    } else {
	      console.log('Modal dismissed for an unknown reason.');
	    }
	  }
	);
  };
}